import { Skeleton } from "@mui/material";
import classNames from "classnames";

import type { TableColumn } from "../types";
import Template from "./Template";

function LoadingRow({ columns, className }: { columns: TableColumn[]; className?: string }) {
    return (
        <Template
            columns={columns}
            cells={columns.map((column) => ({
                columnId: column.id,
                value: "",
            }))}
            className={classNames("border-[#eaeaea]! transition-all", className)}
            renderCell={() => {
                return (
                    <div className={`flex items-center gap-2 py-0! px-1!`}>
                        <Skeleton variant="text" height="2lh" width="100%" />
                    </div>
                );
            }}
        />
    );
}

export default LoadingRow;
